/*
 * Get-category.ts
 * Description: Includes the declaration
 * of the function for getting category data
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Category} from '@/ts/categories/validate-category';


/**
 * Getting category data
 *
 * @return {Object} Promise - category data
 * @param {String} slug - id of a restaurant
 * @param {Category} data - category data
 * @param {Number} categoryId - id of a the category
 */
export function getCategory(slug: string, data: Category, categoryId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/menu-categories/' + categoryId,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data.data.attributes);
        }).catch(() => {
            reject();
        });
    });
}
